import { ConditionValueTypes, OptionTypes } from 'app/components/filters/types';
import { FavouriteConditionValue } from 'app/types-shared';
import { isNumeric } from 'app/infrastructure/data/number';
import { numberFieldOperators } from 'app/components/filters/filters-panel/constants';

export interface NumberFieldCondition {
  number?: number;
  number2?: number;
}

export const createNumberFieldCondition = (
  value: string,
  callback: (favouriteConditionValue: NumberFieldCondition, type?: ConditionValueTypes) => FavouriteConditionValue,
  optionType?: OptionTypes
) => {

  const result = [];
  const trimmedValue = String(value).replace(/ /g, '');
  const splitedValues = trimmedValue.split(',');

  const setNumberEmptyValue = () => {
    result.push(callback({}, ConditionValueTypes.notSpecified));
  };

  const setNumberSingleValue = (number: string, type: ConditionValueTypes) => {
    if (isNumeric(number)) {
      result.push(callback({ number: Number(number) }, type));
    }
  };

  const setNumberRangeValues = (rangeValues: string[]) => {
    const number = Number(rangeValues[0]);
    const number2 = Number(rangeValues[1]);

    if (isNumeric(number) && isNumeric(number2)) {
      result.push(
        callback({ number, number2 }, ConditionValueTypes.numberRange)
      );
    }
  };

  const numberValues = {
    single: (v: string) => Number(v) >= 0 && setNumberSingleValue(v, ConditionValueTypes.numberSingle),
    largerOrEqual: (v: string) => {
      const newValue = v.replace(numberFieldOperators.largerOrEqual, '');
      return v.indexOf(numberFieldOperators.largerOrEqual) > -1
        && setNumberSingleValue(newValue, ConditionValueTypes.numberSingleLargerOrEqual);
    },
    less: (v: string) => {
      const newValue = v.replace(numberFieldOperators.less, '');
      return v.indexOf(numberFieldOperators.less) > -1 && setNumberSingleValue(newValue, ConditionValueTypes.numberSingleLess);
    },
    rangeValues: (v: string) => {
      const rangeValues = v.split(numberFieldOperators.between);
      return rangeValues.length > 1 && setNumberRangeValues(rangeValues);
    },
    empty: () => {
      return setNumberEmptyValue();
    }
  };

  const setNumberValue = (numberValue: string) => {
    if (optionType === OptionTypes.NotSpecified) {
      numberValues.empty();
    } else {
      numberValues.single(numberValue);
      numberValues.largerOrEqual(numberValue);
      numberValues.less(numberValue);
      numberValues.rangeValues(numberValue);
    }
  };

  if (splitedValues.length === 1) {
    trimmedValue && setNumberValue(trimmedValue);
  } else {
    splitedValues.forEach(item => setNumberValue(item));
  }

  return result;
};
